import React, { useState, useEffect } from "react";
// import { Select } from '@windmill/react-ui';
import Select from "react-select";
import FixedItineraryServices from "services/FixedItineraryServices";

const SelectPackage = ({
  register,
  name,
  label,
  selectedVehicle,
  readOnly,
  onChange,
  setNoOfNights,
  setNoOfDays,
  setPackageCode,
  setPackageId,
  setRoute,
  setStateName,
  selectedOptions,
  ...props
}) => {
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "10px 0 -10px 0", // Add margin to the entire option box
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };
  const [allVehicleCategory, setVehicleCategory] = useState([]);
  useEffect(() => {
    async function fetchVehicleCategory() {
      try {
        const response = await FixedItineraryServices.getAllPackage();

        setVehicleCategory(response.data); // Assuming the API response contains an array of profiles
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }

    fetchVehicleCategory();
  }, []);

  const handleSelectChange = (selectedId) => {
    const selectedCategory = allVehicleCategory.find(
      (category) => String(category.package_code) === selectedId
    );

    // Update the parent state with the selected values
    if (selectedCategory) {
      setNoOfNights(selectedCategory.no_of_nights);
      setNoOfDays(selectedCategory.no_of_days);
      setRoute(selectedCategory.route);
      setStateName(selectedCategory.id_state);
      setPackageCode(selectedCategory.package_code);
      setPackageId(selectedCategory.id);
    }
    onChange(selectedId); // Update the package code in the parent component
  };

  const options = Array.isArray(allVehicleCategory)
    ? allVehicleCategory.map((category) => ({
        value: category.package_code,
        label: category.package_code,
      }))
    : [];

  return (
    <Select
      className="h-10 rounded-md dark:text-gray-200 text-sm focus:outline-none block w-full dark:bg-transparent focus:bg-white dark:border-gray-400"
      name={name}
      {...register(`${name}`, {
        required:
          !selectedVehicle || selectedVehicle === "undefined"
            ? `${label} is required!`
            : false,
      })}
      // value={selectedVehicle ? options.find((option) => option.value == selectedVehicle): null}
      value={
        selectedVehicle
          ? options.find(
              (option) => String(option.value) === String(selectedVehicle)
            )
          : null
      }
      {...props}
      onChange={(option) => handleSelectChange(option.value)}
      disabled={readOnly}
      options={options}
      styles={customSelectStyles}
    />
  );
};

export default SelectPackage;
